import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MaskText, FadeUp } from "./MaskText";
import { useLocale } from "@/i18n/LocaleContext";

export const Ventures = () => {
  const { t } = useLocale();

  return (
    <section id="ventures" className="relative border-t border-white/10 py-24 md:py-32" data-testid="ventures-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-20">
          <FadeUp>
            <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-nowi-venture">{t.ventures.kicker}</span>
          </FadeUp>
          <MaskText
            lines={t.ventures.heading}
            className="mt-5 font-playfair italic text-4xl md:text-7xl leading-[0.95] tracking-[-0.02em] max-w-4xl"
          />
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-white/10 border border-white/10 mb-24">
          {t.ventures.chapters.map((c, i) => {
            const n = `0${i + 1}`;
            return (
              <motion.div
                key={n}
                data-testid={`chapter-${n}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, delay: i * 0.12, ease: [0.76, 0, 0.24, 1] }}
                className="group bg-nowi-bg p-9 md:p-11 min-h-[320px] flex flex-col justify-between hover:bg-nowi-surface transition-colors duration-500"
              >
                <div className="font-mono text-6xl md:text-7xl text-white/10 group-hover:text-nowi-venture transition-colors duration-500">{n}</div>
                <div>
                  <h3 className="font-playfair text-3xl md:text-4xl mb-4">{c.title}</h3>
                  <p className="text-nowi-muted text-sm">{c.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>

        <div className="relative border border-white/10 bg-nowi-surface p-8 md:p-16 overflow-hidden" data-testid="founding-block">
          <div className="absolute -top-10 -right-6 font-syncopate font-bold text-[22vw] md:text-[12rem] leading-none text-white/[0.03] select-none pointer-events-none">01</div>
          <div className="relative z-10 max-w-2xl">
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-nowi-venture">{t.ventures.founding.label}</span>
            <MaskText lines={[t.ventures.founding.heading]} className="mt-5 font-playfair text-3xl md:text-5xl leading-[1] tracking-[-0.02em]" />
            <p className="mt-6 text-nowi-muted text-sm md:text-base max-w-xl">{t.ventures.founding.desc}</p>
            <a
              href="#contact"
              data-testid="founding-cta"
              className="mt-9 inline-flex items-center gap-3 border border-white/25 px-8 py-4 text-xs font-mono uppercase tracking-[0.15em] text-nowi-text hover:bg-nowi-venture hover:text-nowi-bg hover:border-nowi-venture transition-colors duration-300"
            >
              {t.ventures.founding.cta}
              <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
